<template>
  <el-container></el-container>
</template>
<script>
export default {
  name: 'wechatLogin',
  data () {
    return {
      ismobile: this.common.isMobile()
    }
  },
  mounted () {
    let query = this.$route.query
    let domain = ''
    let pagePath = query.pagePath !== undefined && query.pagePath !== '/login/login' ? query.pagePath : '/login/wechatLogin'
    if (query.domain === 'localhost') { // 本地测试跳转.
      domain = 'http://localhost:8081'
    } else if (['test.roompai.com', 'test.us.roompai.com', 'www.roompai.com', 'us.roompai.com'].includes(query.domain)) { // 正常环境跳转.
      domain = 'https://' + query.domain
    } else if (window.opener !== null && window.opener.wechatInstanceCallback !== null) { // 当前环境回传数据给母窗口.
      window.opener.wechatInstanceCallback(query)
      window.close()
    } else { // 啥也没找到，跳转到正常的登录页面.
      domain = 'https://' + window.location.hostname
      pagePath = '/login/login'
    }
    if (domain !== '' && pagePath !== '') {
      window.location.href = domain + pagePath + '?code=' + query.code + '&appid=' + query.appid
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/module/wechatLoginPage.vue